import { render, staticRenderFns } from "./TestPageList.vue?vue&type=template&id=47424c53&scoped=true"
import script from "./TestPageList.vue?vue&type=script&lang=js"
export * from "./TestPageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47424c53",
  null
  
)

export default component.exports